import { Box, Button, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const Input = styled(TextField)`
  & {
    background-color: ${(p) => p.theme.palette.common.white};
  }

  > div {
    display: flex;
    height: 45px;
    padding: 10px 7px 10px 11px;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    border-radius: 10px;
    > input {
      padding-top: ${(p) => p.theme.spacing(1)};
      padding-bottom: ${(p) => p.theme.spacing(1)};
    }
  }

  & svg {
    color: #a9a9a9;
    font-size: 24px;
  }
`;

export const SearchButton = styled(Button)`
  border-radius: 8px;
  height: 34px;
  padding: 11px 16px;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: ${(props) => props.theme.palette.text.primary};
  background-color: ${({ theme }) =>
    theme.palette.mode === 'dark'
      ? theme.palette.grey[600]
      : theme.palette.grey[300]};

  &:hover {
    background: ${(props) => props.theme.palette.grey[400]};
  }
`;
